import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import "../../../styles/Auth/subCategory.css";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
    Box, Modal, Button,
    Tooltip, Menu, MenuItem
} from '@mui/material';
import { Icon } from "@iconify/react";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import { postData, uploadFile, getData, putData, deleteData } from "../../../webService/webservice";
import ViewServiceSubCategoryPopup from './subCategoryPopup.jsx';
import { toast } from "react-toastify";
import TVFMLoader from "../Loader/loader.jsx";
import { useStore } from "../../../Context/context.jsx";
import AddStoreForm from "../store/AddStoreForm.jsx";
import StoreMultiSelect from "../../Challange/storeMultiSelect.jsx";
import ServiceCategorySelect from "../../Challange/ServiceCategorySelect.jsx";
import AddServiceCategoryForm from "../ServiceCategory/AddServiceCategoryForm.jsx";
import AddServiceSubCategoryForm from "./AddSubCategoryForm.jsx";
import StoreSingleAllStoresSelect, { ALL_STORE_OPTION } from "../../Challange/StoreSingleAllStoresSelect.jsx";
import Footer from "../Footer/Footer-page.jsx";
import StockImagePicker from "../../../components/Common/ImagePicker/StockImagePicker.jsx";

const ServiceSubCategoryPage = () => {
    const EMPTY_ARRAY = [];
    const navigate = useNavigate();
    const location = useLocation();
    const isAddPage = location.pathname === '/services/sub-category/add';
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const initialStoreId = adminStoreIds[0] || "";
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        display: "flex",
        alignItems: 'center',
        justifyContent: "center"
    };
    const headings = [
        'S.NO',
        'Image',
        'Category Name',
        'SubCategory Name',
        'Action',
    ];
    const [subcategoryImage, setsubCategoryImage] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0);
    const [loading, setLoading] = useState(false);
    const [stores, setStores] = useState([]);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [categories, setCategories] = useState([]);
    const [subcategories, setsubcategories] = useState([]);
    const [viewsubCategoryData, setViewsubCategoryData] = useState(null);
    const [limit, setLimit] = useState(5);
    const [searchQuery, setSearchQuery] = useState('');
    const [openViewPopup, setOpenViewPopup] = useState(false);
    const sessionToken = localStorage.getItem("Token");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [open, setOpen] = useState(false);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editsubCategoryId, setEditsubCategoryId] = useState(null);
    const [subcategoryToDelete, setsubCategoryToDelete] = useState(null);
    const { selectedStoreId, setSelectedStoreId } = useStore();
    const [errors, setErrors] = useState({});
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState(-1);
    const [isAddStore, setIsAddStore] = useState(false);
    const [isAddCategory, setIsAddCategory] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [store, setStore] = useState(ALL_STORE_OPTION);
    const [categoryRefreshKey, setCategoryRefreshKey] = useState(0);
    const [uploadMethod, setUploadMethod] = useState("Normal");
    const [showStockPicker, setShowStockPicker] = useState(false);
    const [selectedStockImage, setSelectedStockImage] = useState(null);

    const fileInputRef = React.useRef(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(null);
    const isActionMenuOpen = Boolean(actionAnchorEl);
    const handleActionClick = (e) => setActionAnchorEl(e.currentTarget);
    const handleActionClose = () => setActionAnchorEl(null);

    const handleBulkUploadClick = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            const sid = (role === "SuperAdmin" || role === "SelfAdmin")
                ? store?.value
                : (Array.isArray(selectedStoreId) ? selectedStoreId[0] : selectedStoreId);

            const storeIdToUse = sid || (stores?.length === 1 ? stores[0]._id : null);

            if (!storeIdToUse) {
                alert("Please select a store before uploading service subcategories");
                return;
            }

            const formData = new FormData();
            formData.append("file", file);
            formData.append("storeIds", storeIdToUse);

            const response = await postData(
                `/servicesubcategories/bulkupload/${userId}`,
                formData,
                token,
                true
            );

            if (response?.success === false) {
                alert(response.message || "Bulk Upload Failed!");
            } else {
                alert("Bulk Service SubCategory Upload Successful!");
                setRefreshKey(prev => prev + 1);
            }
        } catch (error) {
            console.error("Bulk Service SubCategory Upload Failed:", error);
            alert(error?.response?.data?.message || "Error uploading file!");
        } finally {
            if (e.target) e.target.value = "";
        }
    };

    const handleDownloadSampleTemplate = async () => {
        const token = localStorage.getItem("Token");
        const sid = (role === "SuperAdmin" || role === "SelfAdmin")
            ? store?.value
            : (Array.isArray(selectedStoreId) ? selectedStoreId[0] : selectedStoreId);

        const storeIdToUse = sid || (stores?.length === 1 ? stores[0]._id : null);

        if (!storeIdToUse) {
            alert("Please select a store before downloading the sample template");
            return;
        }

        try {
            const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
            const response = await fetch(`${baseUrl}/servicesubcategories/sample-template/${storeIdToUse}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error("Failed to download template");
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "ServiceSubCategories.xlsx";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Failed to generate sample template:", error);
            alert("Failed to generate sample template. Please try again.");
        }
    };

    const handleSort = (field) => {
        const newOrder = sortField === field ? (sortOrder === 1 ? -1 : 1) : -1;
        setSortField(field);
        setSortOrder(newOrder);
    };
    const [showLoader, setShowLoader] = useState(false);
    const [loaderText, setLoaderText] = useState('');

    const [formData, setFormData] = useState({
        storeId: initialStoreId,
        storeName: "",
        serviceCategoryId: '',
        serviceCategoryName: '',
        serviceSubCategoryName: '',
        serviceSubCategoryImageObject: '',
    });

    useEffect(() => {
        const fetchStoreName = async () => {
            if (formData.storeId && !formData.storeName) {
                try {
                    const res = await getData(`stores/store/${formData.storeId}`, {}, sessionToken);
                    if (res?.data) {
                        setFormData(prev => ({ ...prev, storeName: res.data.storeName }));
                    }
                } catch (err) {
                    console.error("Failed to fetch store name", err);
                }
            }
        };
        fetchStoreName();
    }, [formData.storeId, formData.storeName]);

    const loadServiceCategories = async (inputValue, loadedOptions, { page }) => {
        try {
            const params = {
                page,
                limit: 10,
                search: inputValue,
                storeId: formData.storeId || (Array.isArray(selectedStoreId) ? selectedStoreId[0] : selectedStoreId)
            };
            const token = localStorage.getItem("Token");
            const res = await getData('servicecategories/service-categories', params, token);
            const results = res?.data?.results?.[0]?.paginatedResults || [];
            const options = results.map(cat => ({ value: cat._id, label: cat.serviceCategoryName }));
            return { options, hasMore: results.length === 10, additional: { page: page + 1 } };
        } catch (err) {
            return { options: [], hasMore: false };
        }
    };

    useEffect(() => {
        const fetchSubCategories = async () => {
            try {
                const params = {
                    page: currentPage,
                    limit: limit === "all" ? 999999 : limit,
                    search: searchQuery?.trim() || "",
                    sort: JSON.stringify([[sortField, sortOrder]])
                };
                const sid = role === "SuperAdmin" || role === "SelfAdmin" ? store?.value : Array.isArray(selectedStoreId)
                    ? selectedStoreId[0]
                    : selectedStoreId;
                if (sid && sid.length === 24) {
                    params.storeId = sid;
                }
                const data = await getData('servicesubcategories/service-subcategories', params, sessionToken);
                if (data?.status !== 200) {
                    toast.error(data?.message || "Failed to fetch service subcategories");
                    return;
                }
                const results = data?.data?.results?.[0]?.paginatedResults || [];
                setsubcategories(results);
                setTotalPages(data?.data?.results?.[0]?.totalPages || 1);
                setTotalCount(data?.data?.results?.[0]?.totalCount || 0);
            } catch (error) {
                toast.error(error.message || "Failed to fetch service subcategories");
            }
        };
        fetchSubCategories();
    }, [currentPage, limit, refreshKey, searchQuery, selectedStoreId, sortField, sortOrder, store]);

    useEffect(() => {
        const handleStoreChange = () => {
            setCurrentPage(1);
        };
        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    const handleRemoveImage = () => {
        setPreviewUrl(null);
        setsubCategoryImage(null);
        setSelectedStockImage(null);
        setFormData(prev => ({ ...prev, serviceSubCategoryImageObject: null }));
    };

    const handleStockSelect = (imageObject) => {
        if (!imageObject) return;
        setSelectedStockImage(imageObject);
        const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
        const uri = imageObject.uri || imageObject.fileObject?.uri || "";
        if (uri) {
            setPreviewUrl(`${baseUrl}/${uri.replace(/^\/+/, "")}`);
        }
        setShowStockPicker(false);
        setErrors(prev => ({ ...prev, serviceSubCategoryImage: null }));
    };

    const validateFields = (data, method, img, stockImg) => {
        let newErrors = {};
        if (!data.storeId) newErrors.storeId = "Store is required";
        if (!data.serviceCategoryId) newErrors.serviceCategoryId = "Category is required";
        if (method === "Normal" && img) {
            const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
            const allowedExtensions = ["jpg", "jpeg", "png"];
            const fileExtension = img.name.split('.').pop().toLowerCase();
            const isValidType = allowedTypes.includes(img.type) || allowedExtensions.includes(fileExtension);
            if (!isValidType) {
                newErrors.serviceSubCategoryImage = "Only JPEG, JPG, and PNG images are allowed.";
            } else if (img.size > 1024 * 1024) {
                newErrors.serviceSubCategoryImage = "Image size exceeds 1MB. Please select an image smaller than 1MB.";
            }
        }
        if (!data.serviceSubCategoryName?.trim()) newErrors.serviceSubCategoryName = "SubCategory Name is required";
        return newErrors;
    };

    const handleUpdateSubCategory = async (e) => {
        e.preventDefault();
        const validationErrors = validateFields(formData, uploadMethod, subcategoryImage, selectedStockImage);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setErrors({});
        setShowLoader(true);
        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");
            let updatedImageObject = null;
            if (uploadMethod === "Normal") {
                if (subcategoryImage && userId) {
                    const uploadResult = await uploadFile(`files/upload/${userId}`, subcategoryImage);
                    if (uploadResult?.status === 200 || uploadResult?.success) {
                        updatedImageObject = uploadResult.data;
                    } else {
                        toast.error(uploadResult?.message || "Image upload failed");
                        setShowLoader(false);
                        return;
                    }
                } else {
                    updatedImageObject = formData.serviceSubCategoryImageObject;
                }
            } else {
                updatedImageObject = selectedStockImage;
            }
            const updatedSubCategoryData = {
                serviceCategoryId: formData.serviceCategoryId,
                serviceSubCategoryName: formData.serviceSubCategoryName,
                serviceSubCategoryImageObject: updatedImageObject,
                storeId: formData.storeId,
                imageSource: uploadMethod
            };

            const response = await putData(
                `servicesubcategories/service-subcategory/${editsubCategoryId}`,
                updatedSubCategoryData,
                token
            );
            toast.success(response.message || "Service Sub Category updated successfully");
            setIsPopupMode(false);
            setIsEditMode(false);
            triggerRefresh();
        } catch (error) {
            console.error("Update Service SubCategory Error:", error);
            toast.error("Error updating subcategory.");
        } finally {
            setTimeout(() => { setShowLoader(false); }, 2000);
        }
    };

    const handleDeleteSubCategory = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('Token');
            const response = await deleteData(`servicesubcategories/service-subcategory/${subcategoryToDelete}`, token);
            toast.success(response.message || "Service SubCategory deleted successfully");
            setsubCategoryToDelete(null);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete subcategory");
        }
    };

    const handleViewsubCategory = async (subCategoryId) => {
        try {
            setLoading(true);
            const sessionToken = localStorage.getItem("Token");
            const response = await getData(`servicesubcategories/service-subcategory/${subCategoryId}`, sessionToken);
            const data = response?.data || response;
            setViewsubCategoryData(data);
            setOpenViewPopup(true);
        } catch (error) {
            console.error("Error fetching subcategory:", error);
            toast.error(error.message || "Failed to fetch subcategory data");
        } finally {
            setLoading(false);
        }
    };

    const triggerRefresh = () => { setRefreshKey(prev => prev + 1); };
    const handleOpen = (subCategoryId) => { setsubCategoryToDelete(subCategoryId); setOpen(true); };
    const handleClose = () => { setOpen(false); setsubCategoryToDelete(null); };

    const handlePageChange = (direction) => {
        setCurrentPage((prev) => {
            if (direction === "next") return Math.min(prev + 1, totalPages);
            if (direction === "prev") return Math.max(prev - 1, 1);
            if (direction === "first") return 1;
            if (direction === "last") return totalPages;
            return prev;
        });
    };

    const handleItemsPerPageChange = (e) => {
        setLimit(e.target.value === "all" ? "all" : Number(e.target.value));
        setCurrentPage(1);
    };

    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = localStorage.getItem("Token");
                const data = await getData('stores/stores', {}, token);
                setStores(data?.data?.results || []);
            } catch (error) {
                console.error("Failed to load stores", error);
            }
        };
        fetchStores();
    }, []);

    const loadStores = async (inputValue, loadedOptions, { page }) => {
        try {
            const res = await getData("stores/stores", { page, limit: 10, search: inputValue }, sessionToken);
            const results = res?.data?.results || EMPTY_ARRAY;
            const options = results.map(store => ({ value: store._id, label: store.storeName }));
            return { options, hasMore: results.length === 10, additional: { page: page + 1 } };
        } catch (err) {
            return { options: [], hasMore: false };
        }
    };

    return (
        <div className="product-layout">
            <div className="product-content">
                {showLoader && (
                    <div className="scissor-overlay">
                        <div className="scissor-loader"><TVFMLoader /></div>
                    </div>
                )}
                <main className="product-main">
                    {isAddPage ? (
                        <AddServiceSubCategoryForm
                            onSuccess={() => { navigate("/services/sub-category"); triggerRefresh(); }}
                            onCancel={() => navigate('/services/sub-category')}
                            initialStoreId={initialStoreId}
                        />
                    ) : (
                        <>
                            <Typography variant="h6" sx={{ mb: 2 }}>Service Sub Categories</Typography>
                            <div className="product-widgets">
                                <div className="search-input-wrapper">
                                    <input
                                        type="text"
                                        placeholder="Search service sub-categories..."
                                        className="subcategory-search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                    <Icon icon="mdi:magnify" className="search-icon" />
                                </div>
                                {(role === "SuperAdmin" || role === "SelfAdmin") && (
                                    <StoreSingleAllStoresSelect value={store} onChange={(st) => setStore(st)} />
                                )}
                                <div className="add-product-buttons">
                                    <button
                                        className="add-btn-product"
                                        onClick={() => fileInputRef.current?.click()}
                                    >
                                        Import
                                    </button>
                                    <button
                                        className="add-btn-product"
                                        onClick={() => navigate('/services/sub-category/add')}
                                    >
                                        + Add SubCategory
                                    </button>
                                    <button
                                        className="add-btn-product"
                                        onClick={handleDownloadSampleTemplate}
                                    >
                                        Download Sample Template
                                    </button>
                                </div>
                                <input
                                    type="file"
                                    accept=".xlsx, .xls"
                                    style={{ display: "none" }}
                                    ref={fileInputRef}
                                    onChange={handleBulkUploadClick}
                                />
                            </div>
                            <Box component={Paper}>
                                <TableContainer component={Paper} sx={{ maxHeight: '400px', overflowY: "auto" }}>
                                    <Table className="custom-SubCategory-table">
                                        <TableHead className="custom-product-head">
                                            <TableRow>
                                                {headings.map((heading, index) => (
                                                    <TableCell key={index} sx={{ border: "none", padding: "12px 16px", textAlign: "center", position: "sticky", top: 0, zIndex: 10 }}>
                                                        <Typography variant="body2" sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "4px", color: "#ffffffff", fontSize: "14px", fontWeight: 600 }}>
                                                            {heading}
                                                        </Typography>
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {subcategories.length === 0 ? (
                                                <TableRow><TableCell colSpan={5}><Typography sx={{ textAlign: 'center', padding: '20px' }}>No subcategories found.</Typography></TableCell></TableRow>
                                            ) : (
                                                subcategories.map((subcat, index) => (
                                                    <TableRow key={subcat._id}>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {(currentPage - 1) * (limit === 'all' ? 0 : limit) + index + 1}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell><Box sx={{ display: 'flex', justifyContent: 'center' }}><img src={subcat.serviceSubCategoryImageObject?.uri ? `${(process.env.REACT_APP_API_URL || "").replace(/\/+$/, "")}/${subcat.serviceSubCategoryImageObject.uri.replace(/^\/+/, "")}` : "/assets/placeholder.png"} onError={(e) => { e.target.onerror = null; e.target.src = "/assets/placeholder.png"; }} style={{ width: '50px', height: '50px', borderRadius: '8px', objectFit: 'cover' }} /></Box></TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}>{subcat.serviceCategoryId?.serviceCategoryName}</Typography></TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}>{subcat.serviceSubCategoryName}</Typography></TableCell>
                                                        <TableCell>
                                                            <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center' }}>
                                                                <Tooltip title="View Service SubCategory">
                                                                    <Icon icon={plusIcon} width={20} style={{ cursor: 'pointer' }} onClick={() => handleViewsubCategory(subcat._id)} />
                                                                </Tooltip>
                                                                <Tooltip title="Edit Service SubCategory">
                                                                    <Icon icon={editIcon} width={20} style={{ cursor: "pointer" }} onClick={() => {
                                                                        const sId = subcat.storeId?._id || subcat.storeId || "";
                                                                        const sName = subcat.storeId?.storeName || subcat.storeDetails?.[0]?.storeName || stores.find(s => s._id === sId)?.storeName || "";

                                                                        // Determine Category ID vs Object
                                                                        const catObj = subcat.serviceCategoryId;
                                                                        const catId = catObj?._id || catObj || "";
                                                                        const catName = catObj?.serviceCategoryName || subcat.serviceCategoryDetails?.[0]?.serviceCategoryName || "";

                                                                        setFormData({
                                                                            serviceCategoryId: catId,
                                                                            serviceCategoryName: catName,
                                                                            serviceSubCategoryName: subcat.serviceSubCategoryName || '',
                                                                            storeId: sId,
                                                                            storeName: sName,
                                                                            serviceSubCategoryImageObject: subcat.serviceSubCategoryImageObject
                                                                        });
                                                                        setPreviewUrl(subcat.serviceSubCategoryImageObject?.uri
                                                                            ? `${(process.env.REACT_APP_API_URL || "").replace(/\/+$/, "")}/${subcat.serviceSubCategoryImageObject.uri.replace(/^\/+/, "")}`
                                                                            : "/assets/placeholder.png");
                                                                        const method = subcat.imageSource === "Stock" ? "Stock" : "Normal";
                                                                        setUploadMethod(method);

                                                                        if (method === "Stock") {
                                                                            setSelectedStockImage(subcat.serviceSubCategoryImageObject);
                                                                        } else {
                                                                            setSelectedStockImage(null);
                                                                        }

                                                                        // ✅ Always set preview
                                                                        const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
                                                                        const uri = subcat?.serviceSubCategoryImageObject?.uri || "";

                                                                        setPreviewUrl(
                                                                            uri ? `${baseUrl}/${uri.replace(/^\/+/, "")}` : "/assets/placeholder.png"
                                                                        );
                                                                        setsubCategoryImage(null);
                                                                        setEditsubCategoryId(subcat._id);
                                                                        setIsPopupMode(true);
                                                                        setIsEditMode(true);
                                                                    }} />
                                                                </Tooltip>
                                                                {role !== "SelfAdmin" && <Tooltip title="Delete Service SubCategory"><Icon icon={deleteIcon} width={20} style={{ color: '#C10000', cursor: 'pointer' }} onClick={() => handleOpen(subcat._id)} /></Tooltip>}
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <div className="product-bottom">
                                    <div className="category-section show-entries">
                                        <span className="text-label">Show</span>
                                        <select className="entries-select"
                                            value={limit}
                                            onChange={handleItemsPerPageChange}
                                        >
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="all">All</option>
                                        </select>
                                        <span className="text-label">Entries</span>
                                    </div>
                                    <div className="category-section showing-range">
                                        {limit === 'all' ? `Showing all ${totalCount} entries` : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`}
                                    </div>
                                    <div className="category-section spacer"></div>
                                    <div className="category-section pagination-buttons">
                                        <button className="pagination-btn" disabled={currentPage === 1} onClick={() => handlePageChange("first")}><Icon icon="mdi:chevron-double-left" /></button>
                                        <button className="pagination-btn" disabled={currentPage === 1} onClick={() => handlePageChange("prev")}><Icon icon="mdi:chevron-left" /></button>
                                        <button className="pagination-btn" disabled={currentPage === totalPages} onClick={() => handlePageChange("next")}><Icon icon="mdi:chevron-right" /></button>
                                        <button className="pagination-btn" disabled={currentPage === totalPages} onClick={() => handlePageChange("last")}><Icon icon="mdi:chevron-double-right" /></button>
                                    </div>
                                </div>
                            </Box>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <Icon icon={closeIcon} className="popup-close-icon-outside" onClick={() => { setIsPopupMode(false); setIsEditMode(false); }} />
                                        <div className="popup-form">
                                            <Typography variant="h6" sx={{ textAlign: 'center', mb: 4 }}>{isEditMode ? "Edit Service SubCategory" : "Add Service SubCategory"}</Typography>
                                            <form className="popup-form-body" onSubmit={handleUpdateSubCategory}>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label className="input-label">Store Name</label>
                                                        <StoreMultiSelect
                                                            value={formData.storeId ? [{ value: formData.storeId, label: formData.storeName }] : []}
                                                            onChange={(val) => {
                                                                const storeId = val && val.length > 0 ? val[0].value : "";
                                                                const storeName = val && val.length > 0 ? val[0].label : "";
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    storeId: storeId,
                                                                    storeName: storeName,
                                                                    serviceCategoryId: "",
                                                                    serviceCategoryName: ""
                                                                }));
                                                                setCategoryRefreshKey(prev => prev + 1);
                                                            }}
                                                            loadStores={loadStores}
                                                            loggedInRole={role}
                                                            assignedStoreIds={adminStoreIds}
                                                            isMulti={false}
                                                            isDisabled={(role === "StoreAdmin" || role === "StoreManager") && adminStoreIds.length === 1}
                                                            onAddStore={() => setIsAddStore(true)}
                                                        />
                                                        {errors.storeId && <p className="field-error">{errors.storeId}</p>}
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="input-label">Category Name</label>
                                                        <ServiceCategorySelect
                                                            key={`${formData.storeId}-${categoryRefreshKey}`}
                                                            cacheUniqs={[formData.storeId, categoryRefreshKey]}
                                                            value={formData.serviceCategoryId ? { value: formData.serviceCategoryId, label: formData.serviceCategoryName } : null}
                                                            onChange={(val) => {
                                                                setFormData(prev => ({ ...prev, serviceCategoryId: val?.value || "", serviceCategoryName: val?.label || "" }));
                                                                setErrors(prev => ({ ...prev, serviceCategoryId: null }));
                                                            }}
                                                            loadServiceCategories={loadServiceCategories}
                                                            onAddServiceCategory={() => setIsAddCategory(true)}
                                                        />
                                                        {errors.serviceCategoryId && <p className="field-error">{errors.serviceCategoryId}</p>}
                                                    </div>
                                                    <div className="form-group">
                                                        <label>SubCategory Name</label>
                                                        <input type="text" value={formData.serviceSubCategoryName} onChange={(e) => {
                                                            setFormData(prev => ({ ...prev, serviceSubCategoryName: e.target.value }));
                                                            setErrors(prev => ({ ...prev, serviceSubCategoryName: null }));
                                                        }} />
                                                        {errors.serviceSubCategoryName && <p className="field-error">{errors.serviceSubCategoryName}</p>}
                                                    </div>
                                                </div>

                                                <div className="form-group" style={{ gridColumn: 'span 2' }}>
                                                    <label className="input-label">SubCategory Image (Max 1MB, JPEG/JPG/PNG only)</label>
                                                    <div className="upload-options" style={{ display: 'flex', gap: '20px', marginBottom: '12px' }}>
                                                        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                                            <input
                                                                type="radio"
                                                                name="uploadMethod"
                                                                checked={uploadMethod === "Normal"}
                                                                style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                                                onChange={() => {
                                                                    setUploadMethod("Normal");
                                                                    if (subcategoryImage) {
                                                                        setPreviewUrl(URL.createObjectURL(subcategoryImage));
                                                                    } else if (formData.serviceSubCategoryImageObject?.uri) {
                                                                        setPreviewUrl(formData.serviceSubCategoryImageObject?.uri
                                                                            ? `${(process.env.REACT_APP_API_URL || "").replace(/\/+$/, "")}/${formData.serviceSubCategoryImageObject.uri.replace(/^\/+/, "")}`
                                                                            : null);
                                                                    } else {
                                                                        setPreviewUrl(null);
                                                                    }
                                                                }}
                                                            />
                                                            Normal Upload
                                                        </label>
                                                        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                                            <input
                                                                type="radio"
                                                                name="uploadMethod"
                                                                checked={uploadMethod === "Stock"}
                                                                style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                                                onChange={() => {
                                                                    setUploadMethod("Stock");
                                                                    if (selectedStockImage) {
                                                                        const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
                                                                        const uri = selectedStockImage.uri || selectedStockImage.fileObject?.uri || "";
                                                                        setPreviewUrl(`${baseUrl}/${uri.replace(/^\/+/, "")}`);
                                                                    } else {
                                                                        setPreviewUrl(null);
                                                                    }
                                                                }}
                                                            />
                                                            Stock Image
                                                        </label>
                                                    </div>

                                                    {uploadMethod === "Normal" ? (
                                                        <input
                                                            type="file"
                                                            accept=".jpeg,.jpg,.png"
                                                            className="category-input"
                                                            onChange={(e) => {
                                                                const file = e.target.files[0];
                                                                if (file) {
                                                                    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
                                                                    const allowedExtensions = ["jpg", "jpeg", "png"];
                                                                    const fileExtension = file.name.split('.').pop().toLowerCase();
                                                                    const isValidType = allowedTypes.includes(file.type) || allowedExtensions.includes(fileExtension);

                                                                    if (!isValidType) {
                                                                        setErrors(prev => ({ ...prev, serviceSubCategoryImage: "Only JPEG, JPG, and PNG images are allowed." }));
                                                                        toast.error("Only JPEG, JPG, and PNG images are allowed.");
                                                                        setsubCategoryImage(null);
                                                                        setPreviewUrl(null);
                                                                        if (e.target) e.target.value = "";
                                                                    } else if (file.size > 1024 * 1024) {
                                                                        setErrors(prev => ({ ...prev, serviceSubCategoryImage: "Image size exceeds 1MB. Please select an image smaller than 1MB." }));
                                                                        toast.error("Image size exceeds 1MB. Please select an image smaller than 1MB.");
                                                                        setsubCategoryImage(null);
                                                                        setPreviewUrl(null);
                                                                        if (e.target) e.target.value = "";
                                                                    } else {
                                                                        setsubCategoryImage(file);
                                                                        setPreviewUrl(URL.createObjectURL(file));
                                                                        setErrors(prev => ({ ...prev, serviceSubCategoryImage: null }));
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                    ) : (
                                                        <div className="stock-picker-trigger">
                                                            <button
                                                                type="button"
                                                                className="select-stock-btn"
                                                                onClick={() => setShowStockPicker(true)}
                                                                style={{
                                                                    width: '100%',
                                                                    padding: '8px 12px',
                                                                    background: '#fff',
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '6px',
                                                                    cursor: 'pointer',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    textAlign: 'left',
                                                                    justifyContent: 'flex-start',
                                                                    gap: '10px',
                                                                    fontSize: '14px',
                                                                    color: selectedStockImage ? '#333' : '#888'
                                                                }}
                                                            >
                                                                <Icon icon="mdi:image-search" style={{ fontSize: '18px', color: '#64748b' }} />
                                                                {selectedStockImage ? `Selected: ${selectedStockImage.name || 'Stock Image'}` : "Click to select a stock image..."}
                                                            </button>
                                                        </div>
                                                    )}
                                                    {errors.serviceSubCategoryImage && <p className="field-error">{errors.serviceSubCategoryImage}</p>}
                                                    {previewUrl && (
                                                        <div className="image-preview" style={{ marginTop: '12px', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                                            <div style={{ position: 'relative' }}>
                                                                <img src={previewUrl} alt="Preview" style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }} />
                                                                <div
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '-8px',
                                                                        right: '-8px',
                                                                        background: '#ef4444',
                                                                        color: 'white',
                                                                        borderRadius: '50%',
                                                                        width: '20px',
                                                                        height: '20px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        cursor: 'pointer',
                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                                        zIndex: 5
                                                                    }}
                                                                    onClick={handleRemoveImage}
                                                                    title="Remove image"
                                                                >
                                                                    <Icon icon="mdi:close" style={{ fontSize: '14px' }} />
                                                                </div>
                                                            </div>
                                                            {uploadMethod === "Stock" && selectedStockImage && (
                                                                <div style={{ paddingTop: '4px' }}>
                                                                    <p style={{ fontSize: '13px', fontWeight: '600', color: '#1e293b', margin: '0' }}>Stock Image Selected</p>
                                                                    <p style={{ fontSize: '11px', color: '#64748b', margin: '2px 0 0' }}>{selectedStockImage.name}</p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="form-actions">
                                                    <button type="submit" className="add-Product-button">Update SubCategory</button>
                                                    <button type="button" className="cancel-Product-button" onClick={() => setIsPopupMode(false)}>Cancel</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                            >
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 380,
                                        background: "linear-gradient(135deg, #ffffff, #faf5f6)",
                                        borderRadius: "20px",
                                        boxShadow: "0 25px 70px rgba(0,0,0,0.35)",
                                        p: 4,
                                        outline: "none",
                                        textAlign: "center",
                                        overflow: "hidden"
                                    }}
                                >
                                    <Box sx={{
                                        width: 74, height: 74, borderRadius: "50%",
                                        background: "#3C0008",
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        margin: "0 auto 16px auto", color: "#fff", fontSize: 30,
                                        boxShadow: "0 12px 28px rgba(26,30,39,0.55)",
                                        animation: "deletePulse 1.6s infinite ease-in-out",
                                        "@keyframes deletePulse": {
                                            "0%": { transform: "scale(1)", boxShadow: "0 0 0 0 rgba(26,30,39,0.7)" },
                                            "70%": { transform: "scale(1.1)", boxShadow: "0 0 0 18px rgba(26,30,39,0)" },
                                            "100%": { transform: "scale(1)", boxShadow: "0 0 0 0 rgba(26,30,39,0)" },
                                        },
                                    }}>
                                        🗑️
                                    </Box>
                                    <Typography variant="h6" sx={{ fontWeight: 700, color: "#2b2b2b" }}>
                                        Confirm Delete
                                    </Typography>
                                    <Typography sx={{ mt: 1.2, fontSize: 14, color: "#666", lineHeight: 1.6 }}>
                                        Are you sure you want to delete this service subcategory?
                                    </Typography>
                                    <Box sx={{ display: "flex", justifyContent: "center", gap: 2.5, mt: 3.5 }}>
                                        <Button variant="contained" onClick={handleDeleteSubCategory} className="add-Product-button">
                                            Yes, Delete
                                        </Button>
                                        <Button variant="outlined" onClick={handleClose} className="cancel-Product-button">
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                            {openViewPopup && <ViewServiceSubCategoryPopup data={viewsubCategoryData} onClose={() => setOpenViewPopup(false)} />}
                            {isAddStore && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper" style={{ maxWidth: '900px', width: '95%' }}>
                                        <Icon icon={closeIcon} className="popup-close-icon-outside" onClick={() => setIsAddStore(false)} />
                                        <div className="popup-form" style={{ maxHeight: '85vh', overflowY: 'auto', padding: '20px' }}>
                                            <AddStoreForm
                                                onSuccess={(newStore) => {
                                                    setIsAddStore(false);
                                                    if (newStore) {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            storeId: newStore._id,
                                                            storeName: newStore.storeName,
                                                            serviceCategoryId: "",
                                                            serviceCategoryName: ""
                                                        }));
                                                        setCategoryRefreshKey(prev => prev + 1);
                                                    }
                                                }}
                                                onCancel={() => setIsAddStore(false)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                            {isAddCategory && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper" style={{ maxWidth: '900px', width: '95%' }}>
                                        <Icon icon={closeIcon} className="popup-close-icon-outside" onClick={() => setIsAddCategory(false)} />
                                        <div className="popup-form" style={{ maxHeight: '85vh', overflowY: 'auto', padding: '20px' }}>
                                            <AddServiceCategoryForm
                                                key={categoryRefreshKey}
                                                onSuccess={(newCat) => {
                                                    setIsAddCategory(false);

                                                    let catData = Array.isArray(newCat) ? newCat[0] : newCat;
                                                    if (catData && catData.serviceCategory) catData = catData.serviceCategory;
                                                    else if (catData && catData.category) catData = catData.category;

                                                    if (catData) {
                                                        const newId = catData._id || catData.id;
                                                        const newName = catData.serviceCategoryName || catData.Name || catData.name || "New Category";

                                                        setFormData(prev => ({
                                                            ...prev,
                                                            serviceCategoryId: newId,
                                                            serviceCategoryName: newName
                                                        }));
                                                    }
                                                }}
                                                onCancel={() => setIsAddCategory(false)}
                                                initialStoreId={formData.storeId}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                    {showStockPicker && (
                        <StockImagePicker
                            onSelect={handleStockSelect}
                            onCancel={() => setShowStockPicker(false)}
                        />
                    )}
                </main>
                <Footer />
            </div>
        </div>
    );
};

export default ServiceSubCategoryPage;
